export default "__VITE_ASSET__ZnctrZJg__"